import axios from "axios";
import { prodEnv } from "../../env/environment";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { auth } from "../../../firebase/firebase.config";

const apiUrl = prodEnv.API_URL;

// User login
export const login = async (credentials) => {
  try {
    if (!credentials.email || !credentials.password) {
      throw new Error("Email and password are required.");
    }

    const userCredential = await signInWithEmailAndPassword(
      auth,
      credentials.email,
      credentials.password
    );
    const user = userCredential.user;

    if (!user.emailVerified) {
      await signOut(auth);
      throw new Error(
        "Please verify your email before logging in. Check your inbox for the verification email."
      );
    }

    const idToken = await user.getIdToken();
    if (!idToken) {
      throw new Error("No Firebase token found. Please try again.");
    }

    const response = await axios.post(
      `${apiUrl}/users/loginUser`,
      credentials,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    if (response.data?.data?.loginToken) {
      sessionStorage.setItem("token", response.data.data.loginToken);
      const userData = {
        id: response.data?.data?.userId,
        email: credentials.email,
      };
      sessionStorage.setItem("user", JSON.stringify(userData));
      return response.data;
    }

    throw new Error(
      "User not found. Please sign up or use correct credentials."
    );
  } catch (error) {
    console.error(
      "Error during login:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// User signup
export const signup = async (userData) => {
  try {
    if (!userData.email || !userData.password || !userData.name) {
      throw new Error("Name, email, and password are required.");
    }

    const firebaseAuthentication = await createUserWithEmailAndPassword(
      auth,
      userData.email,
      userData.password
    );

    await sendEmailVerification(firebaseAuthentication.user);

    const userCredential = await signInWithEmailAndPassword(
      auth,
      userData.email,
      userData.password
    );
    const user = userCredential.user;

    if (!user.emailVerified) {
      await signOut(auth);
    }

    const response = await axios.post(`${apiUrl}/users/createUser`, userData, {
      headers: { "Content-Type": "application/json" },
    });

    if (
      response.data?.message === "User already exists" &&
      !response.data?.token
    ) {
      return response.data;
    }

    if (response.data.data.jwtToken) {
      sessionStorage.setItem("token", response.data.data.jwtToken);
      const user = {
        id: response.data.data.userId,
        email: userData.email,
      };

      sessionStorage.setItem("name", userData.name);

      sessionStorage.setItem("user", JSON.stringify(user));
    }

    return {
      status: "PENDING_VERIFICATION",
      message:
        "Account created successfully. Please verify your email to continue.",
      data: {
        userId: response.data.data?.userId,
        email: userData.email,
        name: userData.name,
      },
    };
  } catch (error) {
    console.error(
      "Error during signup:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
